import { useMemo } from "react";

import CommonAlert from "@/components/CommonAlert";
import useHotelDepartureProgress from "@/providers/hooks/useHotelDeparture";
import {
    useHotelPlanningDepartureActions,
    useHotelPlanningDepartureShowHotelDepartureProgressDialog,
} from "@/stores/use-hotel-planning-departure-table";

function HotelDepartureProgressDialog() {
    const showHotelDepartureProgressDialog = useHotelPlanningDepartureShowHotelDepartureProgressDialog();
    const { handleHotelDepartureProgress, isPending } = useHotelDepartureProgress();
    const textFlag = useMemo(
        () => (showHotelDepartureProgressDialog?.[0]?.action === "start" ? "departure" : "complete"),
        [showHotelDepartureProgressDialog]
    );

    const { updateShowHotelDepartureProgressDialog } = useHotelPlanningDepartureActions();
    const handleConfirm = async () => {
        if (isPending || !showHotelDepartureProgressDialog) return;
        await handleHotelDepartureProgress(showHotelDepartureProgressDialog);
        handleClose();
    };

    const handleClose = () => {
        updateShowHotelDepartureProgressDialog(null);
    };

    return (
        <CommonAlert
            open={!!showHotelDepartureProgressDialog}
            loading={isPending}
            description={`confirmations.bulkHotelDepartureProgress.${textFlag}`}
            color="primary"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                count: (showHotelDepartureProgressDialog && showHotelDepartureProgressDialog.length) || 0,
            }}
        ></CommonAlert>
    );
}

export default HotelDepartureProgressDialog;
